import {
  type CatalogItemTagIcon,
  CatalogItemTagIcons,
} from '../../value-objects/CatalogItemTag'
import { type ConversationVendor } from '../../value-objects/ConversationTurnItem'
import { CatalogItemTag } from '../CatalogItemTag'
import {
  VendorLogoBadge,
  type VendorLogoBadgeMarkHeight,
} from '../VendorLogoBadge'

const SOURCE_ICONS: Record<string, CatalogItemTagIcon> = {
  catalog: CatalogItemTagIcons.CATALOG,
  history: CatalogItemTagIcons.PREVIOUS_ORDER,
}

export interface IConversationOrderSummarySourceProps {
  vendor: ConversationVendor
  outlined?: boolean
  markHeight?: VendorLogoBadgeMarkHeight
}

export const ConversationOrderSummarySource = ({
  vendor,
  outlined,
  markHeight,
}: IConversationOrderSummarySourceProps) =>
  vendor.logoUrl ? (
    <VendorLogoBadge
      vendor={vendor}
      outlined={outlined}
      markHeight={markHeight}
    />
  ) : (
    <CatalogItemTag icon={SOURCE_ICONS[vendor.id]} text={vendor.name} />
  )
